/**
 * NOTE: Does not support SSR. Use `dynamic(Component, { ssr: false })` for any
 * component that calls this function.
 */
export const browserSupportsAdvancedUpload = () => {
  const div = window.document.createElement('div')
  return (
    ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
    'FormData' in window &&
    'FileReader' in window
  )
}
